import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HocWith = (App) => {
  const Hoc = () => {
    const location = useLocation();
    useEffect(() => {
      // console.log(location,location.state)
      if (location.state === 1) {
        window.scrollTo(0, 1000000000000000);
      } else {
        window.scrollTo(0, 0);
      }
    }, [location]);
    return <App />;
  };
  return Hoc;
};

export default HocWith;
